import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import DatePicker from '../../../shared/form-elements/date-picker/main';
import moment from 'moment';

class Main extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpenDatePicker: false };
		this.toggleDatePicker = this.toggleDatePicker.bind(this);
	}
	toggleDatePicker() {
		this.setState(state => ({ ...state, isOpenDatePicker: !state.isOpenDatePicker }));
	}
	render() {
		const { intl, clear, handleSubmit, fetchData } = this.props;
		return (
			<form
				className="ui-control-bar"
				onSubmit={handleSubmit(fetchData)}
			>
				<div className="ui-control-bar__item modify-item---calendar">
					<div className="ui-control-bar__item-position">
						<Field
							component={DatePicker}
							name="date"
							intl={intl}
							maxDate={moment()}
						/>
					</div>
				</div>
				<div className="ui-control-bar__item">
					<div className="ui-control-bar__item-position">
						<button className="ui-btn ui-btn-primary apply">
							{intl('Apply')}
						</button>
						<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={clear} />
					</div>
				</div>
			</form>
		);
	}
}

export default reduxForm({ form: 'productivityDateForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliate-managers-productivity/components/form/main.js